import { cn } from "@/lib/utils";

export interface TagChipLike {
  name: string;
  is_reserved?: boolean | null;
  /** Vrai quand ce hashtag est réservé à l'activité d'un compte professionnel. */
  is_held?: boolean | null;
}

export const tagChipClassName = (tag: TagChipLike, className?: string): string =>
  cn(
    className,
    tag.is_reserved ? "bg-primary text-primary-foreground hover:bg-primary/90" : undefined,
    !tag.is_reserved && tag.is_held ? "bg-card text-card-foreground" : undefined,
  );

export const tagButtonClassName = (tag: TagChipLike, className?: string): string =>
  cn(
    className,
    tag.is_reserved
      ? "rounded-md bg-primary px-1.5 py-0.5 text-primary-foreground hover:bg-primary/90"
      : undefined,
    !tag.is_reserved && tag.is_held
      ? "rounded-md bg-card px-1.5 py-0.5 text-card-foreground"
      : undefined,
  );
